import { globals } from 'config/globals';
import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType } from 'app/enum/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';
import { Inertia } from 'utils/motion/Inertia';

export class ParticleMouseParallax extends ParticleBehaviour {
	protected _tags: Array<ParticleBehaviourTagType> = [ParticleBehaviourTagType.MOUSE_PARALLAX];

	private _parallaxPower: geometry.Vector2;
	private _x: Inertia;
	private _y: Inertia;

	//PUBLIC METHODS
	//-----------------------------------------------------------------------------------------
	public setup(config: particles.ParticleMouseParallaxConfig): void {
		//Set defaults:
		if (!config.ease) {
			config.ease = { x: 5, y: 5 };
		}

		if (!config.power) {
			config.power = { x: 0.05, y: 0.05 };
		}

		this._x = new Inertia(config.ease.x);
		this._y = new Inertia(config.ease.y);
		this._parallaxPower = { x: config.power.x, y: config.power.y };
	}

	public setPower(power: geometry.Vector2) {
		this._parallaxPower = power;
	}

	public tick(): void {
		if (globals.lastCordsFromTouch) {
			return;
		}
		//Work out how much the particle should be influenced by mouse position:
		this._x.target =
			-1 * (this._sceneProps.mouse.parallax.x * (this._sceneProps.sizes.container.w * this._parallaxPower.x));
		this._y.target =
			-1 * (this._sceneProps.mouse.parallax.y * (this._sceneProps.sizes.container.h * this._parallaxPower.y));

		//Tick inertia forward:
		this._x.tick();
		this._y.tick();

		//Influence the target position on the animated props:
		this._animatedProps.targetX += this._x.value;
		this._animatedProps.targetY += this._y.value;
	}

	public destroy(): void {
		this._x = this._y = null;
	}
}
